import React from 'react';
import { ChevronLeft, ShieldCheck } from 'lucide-react';
import { RETURNS_TITLE, RETURNS_UPDATED, returnsContact, returnsSections } from '../../server/store-returns.js';
import './commerce.css';

// The shop's Returns & Warranty policy (the same words the server puts in the page for search engines).
export default function ReturnsPage({ onBack, contact = {} }) {
  const links = returnsContact(contact);
  const fill = (text) => text.split(/(\{instagram\}|\{email\})/).map((part, index) => part === '{instagram}' ? <a key={index} href={links.instagram}>Instagram</a>
    : part === '{email}' ? <a key={index} href={`mailto:${links.email}`}>{links.email}</a> : part);
  return <article className="privacy-page">
    {onBack && <button type="button" className="shop-link privacy-back" onClick={onBack}><ChevronLeft aria-hidden="true" />Back to the store</button>}
    <header className="privacy-head">
      <span className="shop-eyebrow privacy-eyebrow"><ShieldCheck aria-hidden="true" />Returns</span>
      <h1>{RETURNS_TITLE}</h1>
      <p>Last updated {RETURNS_UPDATED}</p>
    </header>
    {returnsSections(contact).map((section) => <section className="privacy-section" key={section.heading}>
      <h2>{section.heading}</h2>
      {section.paragraphs.map((text, index) => <p key={index}>{fill(text)}</p>)}
    </section>)}
  </article>;
}
